export default __webpack_public_path__ + "static/media/bmi2.258dc3fc.jpg";